import gql from "graphql-tag";

import {
  ADDRESS_FIELDS,
  APPOINTMENT_FIELDS,
  ORGANISATION_BASKET_FIELDS,
  ORGANISATION_BASKET_LINE_ITEM_FIELDS,
  ORGANISATION_CORE_FIELDS,
  ORGANISATION_PATIENT_FIELDS,
  STOCK_BASKET_FIELDS
} from "./shared";

export const CREATE_NEW_ORGANISATION_BASKET_MUTATION = gql`
  mutation CreateOrganisationBasketMutation($input: CreateBasketMutationInput!) {
    createBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const ADD_PRODUCT_TO_ORGANISATION_BASKET_MUTATION = gql`
  mutation AddProductToOrganisationBasketMutation($input: AddProductToBasketMutationInput!) {
    addProductToBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const SET_CYREX_PRODUCT_OPTION_FOR_BASKET_MUTATION = gql`
  mutation SetCyrexProductOptionForBasketMutation(
    $input: SetCyrexProductOptionForBasketMutationInput!
  ) {
    setCyrexProductOptionForBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const SET_PRODUCT_QTY_IN_ORGANISATION_BASKET_MUTATION = gql`
  mutation SetProductQtyInOrganisationBasketMutation($input: SetProductQtyInBasketMutationInput!) {
    setProductQtyInBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const SET_SUPPLEMENT_QTY_IN_ORGANISATION_BASKET_MUTATION = gql`
  mutation SetSupplementQtyInOrganisationBasketMutation(
    $input: SetSupplementQtyInBasketMutationInput!
  ) {
    setSupplementQtyInBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const ADD_ON_TO_PRODUCT_MUTATION = gql`
  mutation AddOnToProductMutation($input: AddOnToProductMutationInput!) {
    addOnToProductMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const APPLY_DISCOUNT_MUTATION = gql`
  mutation ApplyDiscountMutation($input: ApplyDiscountMutationInput!) {
    applyDiscountMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const REMOVE_DISCOUNT_MUTATION = gql`
  mutation RemoveDiscountMutation($input: RemoveDiscountMutationInput!) {
    removeDiscountMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const SET_PATIENT_ON_BASKET_LINE_MUTATION = gql`
  mutation SetPatientOnBasketLineMutation($input: SetPatientOnBasketLineMutationInput!) {
    setPatientOnBasketLineMutation(input: $input) {
      basketLineItem {
        basket {
          id
          organisation {
            id
            name
          }
          organisationPatient {
            ...OrganisationPatientFields
          }
          multiplePatientsEnabled
          patient {
            id
            pk
            user {
              firstName
              lastName
              email
            }
          }
          patientShippingAddress {
            ...AddressFields
          }
          shippingAddress {
            ...AddressFields
          }
          locale {
            id
            name
            isoCode
          }
          paymentLocale {
            id
            name
            isoCode
          }
          invalid
          currencyName
          currencySymbol
          payee
          customsConfirmation
          purchaseAsStock
          commissionPercentageSplit
          appliedTradeDiscount {
            id
            code
          }
          basketShippingCost
          basketOutboundShippingCost
          basketReturnShippingCost
          basketRrpTotalPrice
          basketTotalPrice
          basketTotalCommission
          basketTotalDiscount
          discountInvalidReason
        }
        ...OrganisationBasketLineItemFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_LINE_ITEM_FIELDS}
  ${ADDRESS_FIELDS}
  ${ORGANISATION_PATIENT_FIELDS}
`;

export const REMOVE_PRODUCT_FROM_ORGANISATION_BASKET_MUTATION = gql`
  mutation RemoveProductFromOrganisationBasketMutation(
    $input: RemoveProductFromBasketMutationInput!
  ) {
    removeProductFromBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const CLEAR_BASKET_MUTATION = gql`
  mutation ClearBasketMutation($input: ClearBasketMutationInput!) {
    clearBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const REMOVE_ADD_ON_FROM_PRODUCT_MUTATION = gql`
  mutation RemoveAddOnFromProductMutation($input: RemoveAddOnFromProductMutationInput!) {
    removeAddOnFromProductMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const ADD_SUPPLEMENT_TO_ORGANISATION_BASKET_MUTATION = gql`
  mutation AddSupplementToOrganisationBasketMutation($input: AddSupplementToBasketMutationInput!) {
    addSupplementToBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const REMOVE_SUPPLEMENT_FROM_ORGANISATION_BASKET_MUTATION = gql`
  mutation RemoveSupplementFromOrganisationBasketMutation(
    $input: RemoveSupplementFromBasketMutationInput!
  ) {
    removeSupplementFromBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const UPDATE_ORGANISATION_BASKET_DETAILS_MUTATION = gql`
  mutation UpdateOrganisationBasketDetailsMutation($input: UpdateBasketDetailsMutationInput!) {
    updateBasketDetailsMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const TOGGLE_MULTIPLE_PATIENTS_FOR_BASKET_MUTATION = gql`
  mutation ToggleMultiplePatientsForBasketMutation(
    $input: ToggleMultiplePatientsForBasketMutationInput!
  ) {
    toggleMultiplePatientsForBasketMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const SAVE_PATIENT_MUTATION = gql`
  mutation SavePatientMutation($input: SavePatientMutationInput!) {
    savePatientMutation(input: $input) {
      patient {
        ...OrganisationPatientFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_PATIENT_FIELDS}
`;

export const UPDATE_OR_CREATE_SHIPPING_ADDRESS_MUTATION = gql`
  mutation UpdateOrCreateShippingAddressMutation(
    $input: UpdateOrCreateShippingAddressMutationInput!
  ) {
    updateOrCreateShippingAddressMutation(input: $input) {
      address {
        ...AddressFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
`;

export const SAVE_SHIPPING_ADDRESS_AT_CHECKOUT_MUTATION = gql`
  mutation SaveShippingAddressAtCheckoutMutation(
    $input: SaveShippingAddressAtCheckoutMutationInput!
  ) {
    saveShippingAddressAtCheckoutMutation(input: $input) {
      basket {
        ...OrganisationBasketFields
      }
      address {
        ...AddressFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
  ${ORGANISATION_BASKET_FIELDS}
`;

export const SAVE_ORGANISATION_SHIPPING_ADDRESS_MUTATION = gql`
  mutation SaveOrganisationShippingAddressMutation(
    $input: SaveOrganisationShippingAddressMutationInput!
  ) {
    saveOrganisationShippingAddressMutation(input: $input) {
      organisation {
        ...OrganisationCoreFields
      }
      address {
        ...AddressFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
  ${ORGANISATION_CORE_FIELDS}
`;

export const UPDATE_ORGANISATION_DETAILS_MUTATION = gql`
  mutation UpdateOrganisationDetailsMutation($input: UpdateOrganisationDetailsMutationInput!) {
    updateOrganisationDetailsMutation(input: $input) {
      organisation {
        ...OrganisationCoreFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_CORE_FIELDS}
`;

export const UPDATE_AUTOMATIC_INVOICING_SETTING_MUTATION = gql`
  mutation UpdateAutomaticInvoicingSettingMutation(
    $input: UpdateAutomaticInvoicingSettingMutationInput!
  ) {
    updateAutomaticInvoicingSettingMutation(input: $input) {
      organisation {
        ...OrganisationCoreFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ORGANISATION_CORE_FIELDS}
`;

export const CREATE_PAYMENT_CHECKOUT_SESSION_MUTATION = gql`
  mutation CreatePaymentCheckoutSessionMutation(
    $input: CreatePaymentCheckoutSessionMutationInput!
  ) {
    createPaymentCheckoutSessionMutation(input: $input) {
      address {
        ...AddressFields
      }
      basket {
        ...OrganisationBasketFields
      }
      paymentCheckoutSession {
        id
        url
      }
      organisation {
        ...OrganisationCoreFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
  ${ORGANISATION_CORE_FIELDS}
  ${ORGANISATION_BASKET_FIELDS}
`;

export const ADD_ON_TO_STOCK_MUTATION = gql`
  mutation AddOnToStockMutation($input: AddOnToStockMutationInput!) {
    addOnToStockMutation(input: $input) {
      stockBasket {
        ...StockBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${STOCK_BASKET_FIELDS}
`;

export const REMOVE_ADD_ON_FROM_STOCK_MUTATION = gql`
  mutation RemoveAddOnFromStockMutation($input: RemoveAddOnFromStockMutationInput!) {
    removeAddOnFromStockMutation(input: $input) {
      stockBasket {
        ...StockBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${STOCK_BASKET_FIELDS}
`;

export const CREATE_PAYMENT_INVOICE_MUTATION = gql`
  mutation CreatePaymentInvoiceMutation($input: CreatePaymentInvoiceMutationInput!) {
    createPaymentInvoiceMutation(input: $input) {
      address {
        ...AddressFields
      }
      basket {
        ...OrganisationBasketFields
      }
      paymentInvoice {
        id
        url
      }
      order {
        id
      }
      organisation {
        ...OrganisationCoreFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
  ${ORGANISATION_CORE_FIELDS}
  ${ORGANISATION_BASKET_FIELDS}
`;

export const CREATE_STOCK_PAYMENT_INVOICE_MUTATION = gql`
  mutation CreateStockPaymentInvoiceMutation($input: CreateStockPaymentInvoiceMutationInput!) {
    createStockPaymentInvoiceMutation(input: $input) {
      paymentInvoice {
        id
        url
      }
      stock {
        id
        registeredUser {
          id
          firstName
          lastName
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_PATIENT_ORDER_FROM_BASKET_MUTATION = gql`
  mutation CreatePatientOrderFromBasketMutation(
    $input: CreatePatientOrderFromBasketMutationInput!
  ) {
    createPatientOrderFromBasketMutation(input: $input) {
      address {
        ...AddressFields
      }
      basket {
        ...OrganisationBasketFields
      }
      order {
        id
      }
      organisation {
        ...OrganisationCoreFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
  ${ORGANISATION_CORE_FIELDS}
  ${ORGANISATION_BASKET_FIELDS}
`;

export const INVITE_YOUR_PATIENT_MUTATION = gql`
  mutation InviteYourPatientMutation($input: InviteYourPatientMutationInput!) {
    inviteYourPatientMutation(input: $input) {
      patient {
        id
        patientProfile {
          id
          pk
          user {
            id
            firstName
            lastName
            email
          }
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const RESEND_INVITE_MUTATION = gql`
  mutation ResendOrganisationInviteMutation($organisationId: ID!, $inviteId: ID!) {
    resendOrganisationInviteMutation(organisationId: $organisationId, inviteId: $inviteId) {
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_INVITE_MUTATION = gql`
  mutation DeleteOrganisationPractitionerMutation(
    $input: DeleteOrganisationPractitionerMutationInput!
  ) {
    deleteOrganisationPractitionerMutation(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const REQUEST_ACCESS_TO_RESULTS_MUTATION = gql`
  mutation RequestAccessToResultsMutation($input: RequestAccessToResultsMutationInput!) {
    requestAccessToResultsMutation(input: $input) {
      resultsAccessLink {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const RESEND_REQUEST_TO_ACCESS_RESULTS_MUTATION = gql`
  mutation ResendRequestToAccessResultsMutation(
    $input: ResendRequestToAccessResultsMutationInput!
  ) {
    resendRequestToAccessResultsMutation(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const REMOVE_PATIENT_FROM_ORGANISATION_MUTATION = gql`
  mutation RemovePatientFromOrganisationMutation(
    $input: RemovePatientFromOrganisationMutationInput!
  ) {
    removePatientFromOrganisationMutation(input: $input) {
      patient {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const ACCEPT_ORGANISATION_INVITE_MUTATION = gql`
  mutation AcceptOrganisationInviteMutation($input: AcceptOrganisationInviteMutationInput!) {
    acceptOrganisationInviteMutation(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const SAVE_PATIENT_SHIPPING_ADDRESS_MUTATION = gql`
  mutation SavePatientShippingAddressMutation($input: SavePatientShippingAddressMutationInput!) {
    savePatientShippingAddressMutation(input: $input) {
      address {
        ...AddressFields
      }
      patient {
        id
        shippingAddress {
          ...AddressFields
        }
      }
      errors {
        field
        messages
      }
    }
  }
  ${ADDRESS_FIELDS}
`;

export const SET_ORGANISATION_AS_DEFAULT_FOR_PRACTITIONER_MUTATION = gql`
  mutation SetOrganisationAsDefaultForPractitioner(
    $input: SetOrganisationAsDefaultForPractitionerMutationInput!
  ) {
    setOrganisationAsDefaultForPractitionerMutation(input: $input) {
      organisationPractitioner {
        id
        organisation {
          id
          isDefault
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_APPOINTMENT_MUTATION = gql`
  mutation CreateAppointmentMutation($input: CreateAppointmentMutationInput!) {
    createAppointmentMutation(input: $input) {
      appointment {
        ...AppointmentFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${APPOINTMENT_FIELDS}
`;

export const CREATE_ORGANISATION_PATIENT_REGISTRATION_MUTATION = gql`
  mutation CreateOrganisationPatientFromRegistrationMutation(
    $input: CreateOrganisationPatientFromRegistrationMutationInput!
  ) {
    createOrganisationPatientFromRegistrationMutation(input: $input) {
      organisationPatient {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const SEND_PATIENT_REGISTRATION_VERIFICATION_EMAIL_MUTATION = gql`
  mutation SendPatientRegistrationVerificationEmailMutation(
    $input: SendPatientRegistrationVerificationEmailMutationInput!
  ) {
    sendPatientRegistrationVerificationEmailMutation(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
